import Typography from '@deliveryhero/pd-cookbook/components/Typography';
import { Card, CardActionArea, CardMedia } from '@mui/material';

import { LabelText } from './constants';
import { GiftCardProductsProps } from './types';

import './styles.scss';

export const GiftCardProducts = (props: GiftCardProductsProps) => {
  const { data, selectedCard, handleClick } = props;

  return (
    <div className="gift-card-products-container">
      <div className="gift-card-products-container__title">
        <Typography type="title-md" color="neutral-primary">
          {LabelText.TITLE}
        </Typography>
        <Typography
          type="title-md"
          color="interaction-primary"
          marginLeft="xxs"
        >
          {LabelText.MANDATORY}
        </Typography>
      </div>
      <div className="gift-card-products-container__cards">
        {data[0].themes.map((theme, index) => (
          <Card
            key={index}
            sx={{
              borderRadius: '8px',
              minWidth: '200px',
              minHeight: '120px',
              outline:
                selectedCard && selectedCard.sku == theme.sku
                  ? 'solid 2px #E21B70'
                  : 'solid 1px #DCDCDC',
              outlineOffset: '-1px'
            }}
            variant="outlined"
            onClick={() => handleClick(theme)}
          >
            <CardActionArea>
              <CardMedia
                component="img"
                image={theme.image}
                aria-label={`gift-card-${index}`}
              />
            </CardActionArea>
          </Card>
        ))}
      </div>
    </div>
  );
};
